import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CreateJournalist from './Create';
import api, { FILE_BASE_URL } from '../../utils/api';

const EditJournalist = (props) => {
    const { id } = useParams();
    const [journalist, setJournalist] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        props.setBreadcrumbItems('تعديل صحفي', [
            { title: "الرئيسية", link: "/dashboard" },
            { title: "الصحفيين", link: "/dashboard/journalists" },
            { title: "تعديل صحفي", link: "#" }
        ]);
        fetchJournalist();
    }, []);

 const fetchJournalist = async () => {
   try {
       const response = await api.get(`/journalists/${id}`);

        

        if (response.data && response.data.data) {
            setJournalist(response.data.data);
        } else {
            
            setJournalist(null);
        }
    } catch (error) {
        
        setJournalist(null);
    } finally {
        setLoading(false);
    }
};

    if (loading) return <p>جاري تحميل بيانات الصحفي...</p>;
    if (!journalist) return <p>لم يتم العثور على الصحفي.</p>;

    return (
        <CreateJournalist mode="edit" journalistData={journalist} />
    );
};

export default connect(null, { setBreadcrumbItems })(EditJournalist);
